export default {"src":"/_next/static/media/helicopter_24.870c262e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};